import { configureStore } from '@reduxjs/toolkit';
import rootReducer, { middlewares } from './rootReducer';

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(middlewares),
});

export type AppDispatch = typeof store.dispatch;
export const dispatch = store.dispatch;
export default store;
